module.exports = __webpack_public_path__ + "img/ic_16_share.4236b237.svg";